import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  Grid,
  Chip,
  Button,
  Tooltip,
} from '@mui/material';
import theme from '../../../assets/theme';
import CustomButton from "../../../components/UIComponents/CustomButton"
import { getUnallocatedAmount } from '../../../service/network';
export default function PaymentDetails({ details, tariff, gotoPayments, disableButton = false, unallocatedAmount }) {

  const getAddonServiceCost = () => {
    let tot = 0;
    if (details?.addon_services) {
      for (let srv of details?.addon_services) {
        tot += srv.amount;
      }
    }
    return tot;
  }

  // Check if reservation exists to conditionally show the button
  const hasReservation = details?.name;
  const isButtonDisabled = !hasReservation || disableButton;
  return (
    <Card
      sx={{
        p: 2.5,
        borderRadius: 3,
        backgroundColor: 'light.main',
        boxShadow: 3,
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="SubTitleBold" >
          Payment Details
        </Typography>
        {details?.payment_status ? <Chip
          label={details?.payment_status}
          size="small"
          color="dark.main"
          sx={{
            fontWeight: 600, borderRadius: 1,
            color: "#fff",
            backgroundColor: details?.payment_status === "Completed" ? "green.main" : "orange.main"
          }}
        /> : ""}
      </Box>

      {/* Payment Info */}
      <Grid container spacing={1}>
        <PaymentRow label="Estimated Room Tariff" value={`₹ ${tariff?.estimate?.total ?? 0}`} />
        <PaymentRow label="Calculated Room Tariff" value={`₹ ${tariff?.actual?.total ?? 0}`} />
        <PaymentRow
          label="Unallocated Amount"
          value={`₹ ${unallocatedAmount}`}
        />
        <PaymentRow label="Add-On Services" value={`₹ ${getAddonServiceCost()}`} />
        {/* Total */}
        <PaymentRow
          label="Net Invoiced"
          value={`₹ ${details?.net_amount ?? 0}`}
          highlight
        />

        <PaymentRow label="Tax Amount" value={`₹ ${(details?.invoiced_amount ?? 0) - (details?.net_amount ?? 0)}`} />
        <PaymentRow label="Total Paid" value={`₹ ${details?.paid_amount ?? 0}`} />

        {/* Balance Due */}
        <PaymentRow
          label="Balance Due"
          value={`₹ ${(details?.invoiced_amount ?? 0) - (details?.paid_amount ?? 0)}`}
          highlight
        />
      </Grid>

      {/* Billing Button - Only show if reservation exists */}
       {!disableButton && (
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Tooltip 
            title={!hasReservation ? "Please create or update a reservation first" : ""}
            placement="top"
          >
            <span> {/* This span is needed for the tooltip to work on disabled buttons */}
              <CustomButton 
                variant="contained" 
                color="light" 
                size="small"
                sx={{ borderRadius: theme.borderRadius.medium }}
                onClick={gotoPayments}
                disabled={isButtonDisabled}
              >
                Payments
              </CustomButton>
            </span>
          </Tooltip>
        </Box>
      )}
    </Card>
  );
}
// Reusable row component
const PaymentRow = ({ label, value, highlight }) => (
  <Grid size={12}>
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px={1}
      py={0.5}
      bgcolor={highlight ? '#E1EFFF' : 'transparent'}
      borderRadius={1}
    >
      <Typography
        variant="body2"
        fontWeight={highlight ? 700 : 400}
        color="text.primary"
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        fontWeight={highlight ? 700 : 400}
        color="text.primary"
      >
        {value}
      </Typography>
    </Box>
  </Grid>
);
